import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-dashboard-tab2',
  templateUrl: './admin-dashboard-tab2.component.html',
  styleUrls: ['./admin-dashboard-tab2.component.scss']
})
export class AdminDashboardTab2Component implements OnInit {
  users = ["First Name", "Last Name", "Email", "Plan holder", "Delegate", "License", "Joined", "Cancelled", "Last log in", "Last edit", "Upload into"];
  rowsUsers = [
    {
      "First Name" : "John",
      "Last Name" : "Doe",
      "Email" : "johndoe@gmail.com",
      "Plan holder" : "Yes",
      "Delegate" : "Yes",
      "License" : "Personnel",
      "Joined" : "01/08/2019",
      "Cancelled" : "-",
      "Last log in" : "07/08/2019",
      "Last edit" : "07/08/2019",
      "Upload into" : "Yes"
    },
    {
      "First Name" : "Sam",
      "Last Name" : "Doe",
      "Email" : "johndoe@gmail.com",
      "Plan holder" : "Yes",
      "Delegate" : "Yes",
      "License" : "Personnel",
      "Joined" : "01/08/2019",
      "Cancelled" : "-",
      "Last log in" : "07/08/2019",
      "Last edit" : "07/08/2019",
      "Upload into" : "Yes"
    },
    {
      "First Name" : "Mickael",
      "Last Name" : "Doe",
      "Email" : "johndoe@gmail.com",
      "Plan holder" : "Yes",
      "Delegate" : "Yes",
      "License" : "Personnel",
      "Joined" : "01/08/2019",
      "Cancelled" : "-",
      "Last log in" : "07/08/2019",
      "Last edit" : "07/08/2019",
      "Upload into" : "Yes"
    },
    {
      "First Name" : "Jonathan",
      "Last Name" : "Doe",
      "Email" : "johndoe@gmail.com",
      "Plan holder" : "Yes",
      "Delegate" : "Yes",
      "License" : "Personnel",
      "Joined" : "01/08/2019",
      "Cancelled" : "-",
      "Last log in" : "07/08/2019",
      "Last edit" : "07/08/2019",
      "Upload into" : "Yes"
    },
    {
      "First Name" : "Wiliam",
      "Last Name" : "Doe",
      "Email" : "johndoe@gmail.com",
      "Plan holder" : "Yes",
      "Delegate" : "Yes",
      "License" : "Personnel",
      "Joined" : "01/08/2019",
      "Cancelled" : "-",
      "Last log in" : "07/08/2019",
      "Last edit" : "07/08/2019",
      "Upload into" : "Yes"
    },
    {
      "First Name" : "Bruce",
      "Last Name" : "Doe",
      "Email" : "johndoe@gmail.com",
      "Plan holder" : "Yes",
      "Delegate" : "Yes",
      "License" : "Personnel",
      "Joined" : "01/08/2019",
      "Cancelled" : "-",
      "Last log in" : "07/08/2019",
      "Last edit" : "07/08/2019",
      "Upload into" : "Yes"
    }
  ]
  constructor() { }

  ngOnInit() {
  }

}
